module.exports = __webpack_public_path__ + "img/public/siteImages/rightSideArrow.svg?aba40494";